// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2AT7o","consentsList":"PatientConsents_consentsList__1p_Lt","consentsListEmpty":"PatientConsents_consentsListEmpty__TWNPJ"};